/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { useTheme } from '@mui/material/styles';
import type { ReactNode } from 'react';

export const RadioButton = ( { checked }: { checked?: boolean } ): ReactNode => {
	const theme = useTheme();
	const color = checked ? theme.palette.primary.main : theme.palette.text.secondary;

	return (
		<svg
			width="18px"
			height="18px"
			viewBox="0 0 24 24"
			fontSize="18px"
		>
			<circle
				cx="50%"
				cy="50%"
				r="11px"
				stroke={ color }
				strokeWidth={ '1px' }
				fill="none"
			/>

			{ checked && (
				<circle
					cx="50%"
					cy="50%"
					r="6px"
					fill={ color }
				/>
			) }
		</svg>
	);
};
